/* ==========================================================================
   Bronzed By Carrot — Direct to checkout.
   When enabled (store setting `cart_direct_checkout`, default ON), ANY
   add-to-cart form submit adds the item then sends the shopper straight to
   /checkout, skipping the cart drawer / cart page.

   Mechanism: a single capture-phase 'submit' listener on document. Capture runs
   before Dawn's form-bound submit handler, and stopImmediatePropagation() stops
   Dawn's handler from firing at all, so the drawer/notification never opens.
   - Main buy box: native <product-form> submit -> intercepted here.
   - Sticky ATC (bc-pdp.js): proxies a .click() to the native button, which
     submits the same form -> intercepted here too.
   - Bundle builder: does its own multi-add fetch on a button click (not a form
     submit) and handles its own redirect; it is intentionally NOT touched here.
   Toggle the setting OFF to restore Dawn's native cart-drawer behaviour.
   ========================================================================== */
(function () {
  'use strict';

  function enabled() {
    return window.bcCartDirectCheckout !== false;
  }

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  document.addEventListener(
    'submit',
    function (e) {
      if (!enabled()) return;

      var form = e.target;
      if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

      var btn = form.querySelector('[name="add"], [type="submit"]');
      // Respect Dawn's disabled / sold-out / mid-flight states.
      if (btn && (btn.disabled || btn.getAttribute('aria-disabled') === 'true')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      if (btn) {
        btn.setAttribute('aria-disabled', 'true');
        btn.classList.add('loading');
        var sp = btn.querySelector('.loading__spinner');
        if (sp) sp.classList.remove('hidden');
      }

      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok) throw res.data;
          window.location.href = root() + 'checkout';
        })
        .catch(function (err) {
          // Restore the button and surface Dawn's error UI on failure.
          if (btn) {
            btn.removeAttribute('aria-disabled');
            btn.classList.remove('loading');
            var sp2 = btn.querySelector('.loading__spinner');
            if (sp2) sp2.classList.add('hidden');
          }
          var msg = (err && (err.description || err.message)) || '';
          var pf = form.closest('product-form');
          var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
          var el = wrap && wrap.querySelector('.product-form__error-message');
          if (msg && wrap && el) {
            el.textContent = msg;
            wrap.removeAttribute('hidden');
          }
        });
    },
    true // capture: beat Dawn's product-form submit handler
  );
})();
